module.exports = __webpack_public_path__ + "static/media/gc.3a381e4c.jpg";